export const topVenues2025 = [
  "rosewood-mayakoba",
  "grand-velas-riviera-maya",
  "esperanza-auberge",
  "general-prim-mexico-city",
  "rosewood-san-miguel",
  "one-only-palmilla",
  "four-seasons-pv",
  "nizuc-resort",
  "acre-resort",
  "banyan-tree-mayakoba"
];

export const bestLuxuryVenues = [
  "rosewood-mayakoba",
  "grand-velas-riviera-maya",
  "esperanza-auberge",
  "one-only-palmilla",
  "four-seasons-pv",
  "nizuc-resort",
  "banyan-tree-mayakoba"
];

export const bestBeachfrontVenues = [
  "rosewood-mayakoba",
  "grand-velas-riviera-maya",
  "esperanza-auberge",
  "one-only-palmilla",
  "four-seasons-pv",
  "nizuc-resort",
  "banyan-tree-mayakoba"
];

export const bestHistoricVenues = [
  "general-prim-mexico-city",
  "rosewood-san-miguel"
];

export const bestBoutiqueVenues = [
  "acre-resort"
];

export const bestAllInclusiveVenues = [
  "grand-velas-riviera-maya",
  "secrets-maroma"
]; 